/* global localStorage, alert, document */

import $ from 'jquery'
import cartApi from './api'
import _ from './constants'

export const toggle = (state) => {
  if (state === 'close') {
    _.cartSwitch.innerText = 'Cart'
    _.body.classList.remove('cart-is-open')
    document.documentElement.classList.remove('cart-is-open')
  } else {
    _.cartSwitch.innerText = 'Close'
    _.body.classList.add('cart-is-open')
    document.documentElement.classList.add('cart-is-open')
  }
}

export const slideOut = () => {
  _.cartSwitch.onclick = (e) => {
    e.preventDefault()
    if (_.body.classList.contains('cart-is-open')) {
      toggle('close')
    } else if (_.header.classList.contains('is-open')) {
      _.header.classList.remove('is-open')
      setTimeout(() => {
        toggle('open')
      }, 500)
    } else {
      toggle('open')
    }
  }

  for (const target of _.mainAndFooter) {
    target.onclick = () => {
      if (_.body.classList.contains('cart-is-open')) toggle('close')
    }
  }
}

export const adjustCart = () => {
  for (const qty of document.querySelectorAll('.c-qty--minus, .c-qty--plus')) {
    qty.onclick = (e) => {
      cartApi.adjust(e.target.getAttribute('data-line'), e.target.getAttribute('data-qty'))
    }
  }
}

export const addToCart = () => {
  for (const form of _.addToCartForm) {
    form.onsubmit = (e) => {
      e.preventDefault()

      const productType = e.target.querySelector('#type').value
      const type = localStorage.getItem('type')

      if (productType !== type) {
        localStorage.setItem('type', productType)
        if (type !== null) {
          cartApi.clear()
        }
      }

      setTimeout(() => {
        cartApi.add($(form).serialize())
      }, 100)
    }
  }
}

export const closeUpsell = () => {
  for (const upsell of _.upsell) {
    const upsellClose = upsell.querySelector('.c-cart__upsellClose')

    upsellClose.onclick = (e) => {
      e.preventDefault()
      upsell.classList.remove('is-active')
    }
  }
}

export const addUpsellToCart = () => {
  for (const upsell of _.upsell) {
    const add = upsell.querySelector('.c-cart__upsellAdd button')
    add.onclick = (e) => {
      e.preventDefault()

      setTimeout(() => {
        cartApi.add(`id=${e.target.dataset.variant}`)
      }, 100)

      setTimeout(() => {
        upsell.classList.remove('is-active')
      }, 500)
    }
  }
}

// which checkout to use based on whether cart has subscription product in it
export const checkout = () => {
  _.cartForm.onsubmit = (e) => {
    e.preventDefault()

    $.getJSON('/cart.js', (data) => {
      let url = '';
      const book         = data.items.filter(item => item.product_type === 'Book').length
      const subscription = data.items.filter(item => item.product_type === 'Subscription').length
      const sub_url = `https://checkout.rechargeapps.com/r/checkout?myshopify_domain=seedlip-development.myshopify.com&cart_token=${
        data.token
      }`

      if (subscription > 0) {
        url = sub_url
      } else {
        url = '/checkout'
      }

      window.location.href = url
    })
  }
}

// when clicking a submit button on a radio item, mark the relevant input as checked
export const radioSelect = () => {
  for (const rs of _.radioSubmit) {
    rs.onclick = (e) => {
      if (rs.classList.contains('s-product__sub-toggle--active')) {
        rs.classList.remove('s-product__sub-toggle--active')
        rs.textContent = 'Choose'

        setTimeout(() => {
          rs.parentNode.querySelector('input[type="radio"]').checked = false
        }, 500)
      } else {
        e.preventDefault()

        for (const r of _.radioSubmit) {
          r.classList.remove('s-product__sub-toggle--active')
          r.textContent = 'Choose'
        }

        rs.classList.add('s-product__sub-toggle--active')
        rs.textContent = 'Proceed'
        rs.parentNode.querySelector('input[type="radio"]').checked = true
      }
    }
  }
}
